export default [
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/eyip8jyref04docmyp2r.jpg',
		name: `Zouhir ⚡`,
		bio: `Edge Microsoft  | Google Dev Expert`,
		link: `https://twitter.com/_zouhir/status/972213169891426305`,
		text: `Shit, I didn't know that!!!!!!! <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/_zouhir/status/972213169891426305"><strong>This VSCode tip is life changing to me!!</strong></a>— Said in response to a <a target="_blank" rel="noopener noreferrer" href="https://vscode.pro/tip/5">VSCode tip</a> shared by Ahmad at Twitter.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/kaqvaoafiqnu5y6znbn4.jpg',
		name: `Alberto Medina`,
		bio: `Google Developer Advocate | Ph.D CS`,
		link: `https://twitter.com/iAlbMedina/status/1065350099562246144`,
		text: `<strong>Wow; the quality of the courses is outstanding. Really great work Ahmad</strong>! Great VSCode course; awesome work!`,
	},
	{
		img: 'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/vq07tweueuxlcwdzuswj',
		name: `Sarah Drasner`,
		bio: `JS Microsoft & Vuejs Core Team`,
		link: `https://twitter.com/sarah_edo/status/1075393831388889091`,
		text: `Today for #devAdvent: the very hardworking <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">@MrAhmadAwais</a>! Ahmad is a WordPress Core member and TEDx speaker and he recently created a course to help people become VS Code Power Users. <strong>If you're using VSCode as your editor, <a href="https://VSCode.pro">VSCode.pro</a> is a fun/cool resource!</strong> `,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/oef3cb7monwrgjnvyrst.jpg',
		name: `Matt Mullenweg`,
		bio: `Co-Founder of WordPress`,
		link: `https://ahmadawais.com/think-like-a-block/`,
		text: `Ahmad's Open Source: "<strong>It's very impressive</strong>". — <a target="_blank" rel="noopener noreferrer" href="https://ahmadawais.com/won-automattic-design-award-appreciation-matt-mullenweg/">Won <strong>Automattic Design Award Trophy</strong></a>. The create-guten-block project is an awesome awesome contribution to the community <a target="_blank" rel="noopener noreferrer" href="https://ahmadawais.com/think-like-a-block/">— at AWP Gutenberg series.</a>`,
	},

	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/rx3fczmxvbl9djzevqdr.jpg',
		name: `Jan Koch`,
		bio: `Mentor at WPMastery`,
		link: `https://twitter.com/iamjankoch/status/1064118588729163776`,
		text: `I also just made the <strong>decision to move away from PHPStorm to VSCode. I mean, just one year in license fees pays for the VSCode.pro master package and I'll learn from one of the best</strong> Just by going through the UI improvements videos, I can already see how the course will help me become #VSCODEpro`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/ykkvjnbrs6r1lztpfquk.jpg',
		name: `Dan Abramov`,
		bio: `Core Dev ReactJS at Facebook`,
		link: `https://twitter.com/dan_abramov/status/990666025657143296`,
		text: `"<strong>OMG awesome</strong>. How do you find those class names?"  — Said in response to a <a target="_blank" rel="noopener noreferrer" href="https://vscode.pro/tip/1">VSCode tip</a> shared by Ahmad on Twitter.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/dj8nvaunkoceyaghbkwy.jpg',
		name: `Benjamin Lannon`,
		bio: `VSCode Extensions Developer in NY`,
		text: `It’s a 5 hour course that teaches you a huge amount of knowledge and after going through it myself, <strong>I can state that even as a fairly advanced user of VS Code, Ahmad taught me some neat tricks that I immediately am integrating into my workflow now</strong>.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/sai7c8a4fhtvapwtmhnx.jpg',
		name: `Haris Zulfiqar`,
		bio: `Founder Avada | Engineer at WDS`,
		link: `https://twitter.com/mharis/status/1065340213545889793`,
		text: `I've been using VSCode for a few months and I'm not a power user at all. Thanks to @MrAhmadAwais for creating an amazing course to help me bridge that gap in a short time. <strong>I highly recommend his course if you're looking to level up your VSCode game.</strong>`,
	},

	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/sztiftj5tjbgmxci5j2o.jpg',
		name: `Jeremy Englert`,
		bio: `Core Contributor ZURB Foundation`,
		link: `https://twitter.com/JeremyEnglert/status/1063536297845772288`,
		text: `If you're looking to expand your VSCode knowledge, <strong>I have no doubt this course will be extremely useful. <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">@MrAhmadAwais</a> does great work</strong>.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/qq02sr589shrpczovlwx.jpg',
		name: `Mike Stott`,
		bio: `Core Contributor ZURB Foundation`,
		link: `https://twitter.com/mikemayhem3030/status/1063557678037913600`,
		text: `Just grabbed <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MrAhmadAwais/">@MrAhmadAwais</a>'s #VSCODEpro course masterclass. If you use any code editor, make the move. Support Ahmad :) he's a top guy — does great work. → VSCcode.pro`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/xdpcinx1vnri0toigzkc.jpg',
		name: `Ali Spittel`,
		bio: `Tech Director WomenWhoCode`,
		link: `https://twitter.com/aspittel`,
		text: `I love this theme! Themes with more unique colors like purple are relatively rare, so it's great to see purple represented here. It's a fun theme, and it's easy to read!`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/ndpelpoz760k8jbxsisy.jpg',
		name: `Raghu Vamsi`,
		bio: `SCRUM Master + Front End Dev`,
		link: `https://twitter.com/MrAhmadAwais/status/1064247507063136256`,
		text: `Kudos to the teacher @MrAhmadAwais for making the #VSCODEpro learning a breeze. I am on the 14th chapter and this is getting as exciting as a binge learning. Ahmad, your hard work is making a student's life easy. You deserve great respect`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/chp5hl8xma2a0wg6glzl.jpg',
		name: `Matt Cromwell`,
		bio: `Partner/Head Community Impress.org`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `<strong>I always find him to be an excellent communicator, highly skilled, considerate, and extremely generous</strong>. He's a pleasure to collaborate with and he's produced some very impressive public and FREE #OpenSource work for developers to learn and benefit from. In my book, those are some of the best characteristics to have in a person. Ahmad is highly recommended.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/ojvwntefcqrx8xwbrx8a.jpg',
		name: `Lee Peterson`,
		bio: `Creative Lead at Rusty Dog Design`,
		link: `https://twitter.com/dan_abramov/status/990666025657143296`,
		text: `<strong>I've never known someone to create such useful things on a regular basis.</strong> Truly impressive sir. I mean it. You just pump stuff out. It's incredible.`,
	},

	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/cfvrauwk9fh60pqpaqim.jpg',
		name: `Alex Coleman`,
		bio: `Web Designer at LeftSideDesign`,
		text: `I've read over Ahmad's tutorial a few times and implemented most of it. <strong>He's the bee's knees for this kind of stuff.</strong> — In ref to the WordPress &amp; Gulp implementation via <a target="_blank" rel="noopener noreferrer" href="https://github.com/ahmadawais/WPGulp">WPGulp</a>.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/ojvxfzffi874hrckmg4a.jpg',
		name: `Shawn Swyx Wang`,
		bio: `Dev Experience @Netlify | Reactjs`,
		link: `https://twitter.com/swyx`,
		text: `This is a gorgeous, high contrast theme that stands out without getting in the way. Especially great for doing developer talks and screencasts and maintained by a supremely dedicated expert in all the VSCode pro tips. The documentation itself is a thing of beauty, too. 5 Stars!`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/iukzxhuyocbe9ggjj0lx.jpg',
		name: `Josh Pollock`,
		bio: `Lead Dev & Founder CalderaWP`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `Yes, Ahmad writes great WordPress tutorials and makes great looking themes and websites, but that's not the only reason I endorse Ahmad. Ahmad is a great community member, he is a core contributor to WordPress and always helpful to other WordPress users. Also, he is a really nice guy, which is important.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/sou6em8xotnysikgm1wx.jpg',
		name: `Japheth Thomson`,
		bio: `Director of Hosting at Human Made`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `Ahmad has written tutorials for me to publish at Tuts+ on a number of occasions, and I always appreciate his level of expertise both in the subject matter…, and in helping to educate others. I would hire Ahmad again for… training or consultancy in a heartbeat.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/ive0oxqnzie6v0jqaqwj.jpg',
		name: `Jabran Rafique`,
		bio: `Tech Lead at Rated People`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `I know Awais from his contributions to world wide web. His expertise in web & software technologies and his contributions to various open-source projects make it stand out of the crowd. I highly recommend Ahmad.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/rzgejom0rr4nx2xoif6e.jpg',
		name: `Stanislav Khromov`,
		bio: `Dev at Schibsted Media Group`,
		text: `I'm really impressed with how much you are participating in the community! It's pretty insane. <strong>You're probably one of the most engaged people</strong>  I have seen, ever.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/rdhpto2fggavoigov9tx.jpg',
		name: `Emil Uzelac`,
		bio: `WordPress Quality Control Specialist`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `It is extremely rare that you come across highly skilled talent like Ahmad! We worked together on several occasions over the years and his efficiency is beyond superior.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/nzggujglivxhhdmii9ws.jpg',
		name: `Mike Andreasen`,
		bio: `WordPress Expert at Codeable`,
		link: `https://www.linkedin.com/in/mrahmadawais/`,
		text: `Ahmad regularly contributes to WordPress core for code and UX improvements. He is one of the most passionate developers I have ever met with an insatiable desire to streamline the workflow of the process of everything he works on. He dives in head first to any new challenges and conquers them with his tenacity and intelligence which make Ahmad an invaluable asset to any project.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/xme1sfmxrf44ma0sbquy.jpg',
		name: `Daan Toll`,
		bio: `Owner of WPLift`,
		text: `Ahmad is a very thorough writer and he <strong>is extremely knowledgeable of the WordPress industry. He knows exactly what is going on in the WordPress community</strong> and his outreach is an addition to any blog. I would recommend him.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/somcnov0wc8n4nix2r2z.jpg',
		name: `Adam Hollister`,
		bio: `Lead Developer at The British & Irish Modern Music Institute`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `I switch syntax themes so often, but I haven't felt the need to switch since using Shades of Purple for the past 6 months, it's my new default - keep up the good work man!`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/aodwsxntpvhkkph6ysqa.png',
		name: `B ...`,
		bio: `SOP Review`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `Amazing job with balancing out the colors to ensure it's not overloading the eyes. The comments, and markdown syntax semi-hidden state styling is also a good idea! If it's not critical to always see this information then it makes sense to reduce it's visibility. Nice job mate.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/esipos2hi4vx6kiomved.jpg',
		name: `Ignacioaal`,
		bio: `Rails Hacker`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `I jumped ship from Cobalt 2 by Wes to Shades of Purple theme by Ahmad Awais and I'm not looking back, beautiful shades of purple lighten up my code in a way that no other theme can, great job Ahmad!`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/d5kg9f2tu8h8ftmpofii.jpg',
		name: `Wayne`,
		bio: `Devs at Go6 Media`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `At go6.media we always use Shades of Purple for all our PHP/HTML/JS/CSS and other languages. It's so beautiful and easy to read, we also added some slight tweaks to make it even better and we could not be happier that we found it. Thank you!`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/lyafmwxsakspeen5hzgi.jpg',
		name: `Mark Porter`,
		bio: `Dev at PorterPeople`,
		link: `https://github.com/ahmadawais/shades-of-purple-vscode/issues/15`,
		text: `Ahmad takes his extension seriously and fixed a bug for me overnight. A fantastic theme that is both attractive but more importantly, effective in bring your attention to the import parts of your code.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/u8bzrybuagxmxptkkijk.jpg',
		name: `Uche Jude`,
		bio: `Software Developer Andela`,
		link: `https://twitter.com/iamuchejude`,
		text: `I started loving the Shades of Purple theme from its name ;) After seeing images of the themes, I saw there was more and to get to know about the 'more', an installation will have to occur which did occur...After installation, I got to find out that the theme is super duper awesome than I thought… Welldone Ahmad Awais`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/epvrcnvwm3lupnwbamew.jpg',
		name: `Alexandra Spalato`,
		bio: `Javascript & WordPress Developer`,
		link: `https://twitter.com/alexadark`,
		text: `Just installed Shades of Purple and absolutely love it! Thank you for creating it! I love these colors! I also switched from Cobalt2. And just beginning a new job as a React.js dev, with it :-)`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/u8bzrybuagxmxptkkijk.jpg',
		name: `Ojo Oluwasetemi`,
		bio: `JavaScript Dev & Teacher`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `I started using SOP during the better release and ever since it has being a perfect choice for me. Love to see my IDE always with the shades of purple splash. It improved my overall workflow. Thanks @AhamadAwais for such work.`,
	},
	{
		img:
			'https://res.cloudinary.com/cdemo/image/upload/w_54,h_54,q_auto,f_auto/Placeholders/nzpwbu1krtgxueiz2ggv.jpg',
		name: `Ajit Bohra`,
		bio: `Engineer & Speaker @lubusIN`,
		link: `https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple#review-details`,
		text: `Have been using Shades of Purple theme for the last couple of weeks and in love with it. Its fun writing code with those shades of purple <3`,
	},
];
